import React from 'react'
import { withRouter } from 'react-router-dom'
import Page from '../components/Page'
import Interface from '../components/Interface'
import api from '../shared/api'

import '../stylesheets/pages/Board.scss'

class Board extends React.Component {
    state = {
        loading: false,
        done: false,
        results: null,
    }
    handleNext = () => {
        this.setState({ loading: true, done: false })
        api.store(
            this.props.match.params.slug,
            window.localStorage.getItem(this.props.match.params.slug) || null,
            this.state.results,
        ).then((response) => {
            this.setState({ loading: false })
            let next = parseInt(this.props.match.params.round) + 1
            next =
                next > this.props.rounds.length
                    ? `/${this.props.match.params.slug}/thanks`
                    : `/${this.props.match.params.slug}/board/${next}`
            this.props.history.push(next)
        })
    }
    handleUpdate = (done, results) => {
        this.setState({ done, results })
    }
    render() {
        return (
            <Page
                title={
                    this.props.rounds.find(
                        (round) => round.round === parseInt(this.props.match.params.round),
                    ).description
                }
                button={this.props.validation.button}
                text={this.props.validation.text}
                enabled={this.state.done}
                action={this.handleNext}
                loading={this.state.loading}
                call={this.props.validation.board_button}>
                <div className="Board">
                    <Interface {...this.props} update={this.handleUpdate} />
                </div>
            </Page>
        )
    }
}

export default withRouter(Board)
